import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input, Switch } from "antd";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";

interface ImageSection {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  imageData?: string[];
  loading?: boolean;
  hanldeSaveToggleStatus?: (payload: {
    section: string;
    isHidden: boolean;
  }) => void;
}

const ImageSection: React.FC<ImageSection> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  imageData,
  loading,
}) => {
  useEffect(() => {
    if (imageData) {
      form.setFieldsValue({
        galleryImages: imageData,
      });
    } else {
      form.resetFields();
    }
  }, [imageData, form]);
  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-x-auto hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left text-sm md:text-base">
                    Images
                  </th>
                  <th className="py-3 px-4 text-end text-sm md:text-base ">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {imageData ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 w-full flex gap-2 items-center">
                      {(imageData ?? []).slice(0, 5).map((image, index) => (
                        <Image
                          key={index}
                          src={image}
                          height={50}
                          width={120}
                          className="object-contain w-full h-[50px] rounded border"
                          alt="Image"
                        />
                      ))}

                      {(imageData?.length ?? 0) > 5 && (
                        <div
                          className="w-[60px] h-[40px] flex items-center justify-center
                          bg-gray-200 text-sm rounded border"
                        >
                          +{(imageData?.length ?? 0) - 2}
                        </div>
                      )}
                    </td>
                    <td className="py-3 px-4 h-full text-primary">
                      <div className="flex items-center justify-end gap-4 h-full">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[20px]"
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden">
            {imageData ? (
              <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Images:
                  </span>
                  <p className="flex gap-2">
                    {" "}
                    {imageData?.slice(0, 5)?.map((image, index) => (
                      <Image
                        key={index}
                        src={image}
                        height={70}
                        width={70}
                        className="object-contain w-full h-full"
                        alt="Banner"
                      />
                    ))}
                  </p>
                </div>

                <div className="">
                  <span className="font-semibold text-primary block mb-1">
                    Action:
                  </span>
                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-black text-[18px]"
                  />
                </div>
              </div>
            ) : (
              <div className="bg-[#F9F9F9] border flex justify-center border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  {" "}
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Image"
                name="galleryImages"
                rules={[{ required: true, message: "Please upload a image" }]}
              >
                <UploadFoodImage maxUploadCount={40} bannerAspect={1} />
              </Form.Item>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSection;
